module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "24",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('h1', {
    staticClass: "CT"
  }, [_vm._v("2001–2010 State DREAM Acts and Litigation")])]), _vm._v(" "), _c('p', {
    staticClass: "FMCO"
  }, [_vm._v("The DREAM Act (for Development, Relief, and Education for Alien Minors) was introduced in the United States Senate in 2001. The original and subsequent bills never passed Congress, yet the effects on undocumented college students have been prominent in the news media and on federal and state legislative agendas to this day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-1",
      "id": "chapter2_1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Presidential candidates in 2008, 2012, and 2016 would debate the DREAM Act and the issues it addressed. Especially coming on the heels of a near-miss passage in 2007, when the bill almost gained approval in the Senate, the issue of undocumented college residency has all the earmarks of an agenda-building subject, situated in the complex and treacherous context of modern policy debate, especially comprehensive immigration reform. Given that the DREAM Act’s subset of larger immigration, higher education, and tuition policies commands our attention, its politics are a useful bellwether for astute observers of domestic politics in the twenty-first century.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("This chapter examines the general topic of undocumented college residency, played out in state DREAM Acts, and to a great extent reveals the difficulty inherent in conducting research on pending legislation, especially legislation that is so fluid and so embedded in a larger, systemic regime, and includes the background for the DREAM Act, at the state and federal level. I review the extensive litigation and legal developments, as well as the several state DREAM Acts and other issues concerning college residency and tuition. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" reviews the federal DREAM Act and its failure to gain traction during votes in the US House and Senate. I consider the politics of immigration reform that are the backdrop for these developments, and the conclusion assesses the prospects for enactment of the legislation, either as a standalone statute or, more likely, as one of many components in the larger comprehensive immigration reform efforts. Considering how small this undocumented college student population is in the larger scheme of things (never more "), _c('span', {
    attrs: {
      "aria-label": "25",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("than 50,000 or 60,000 each year by any estimates),"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-2",
      "id": "chapter2_2",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" extensive state and national legislative history reveals a surprising degree of attention in the polity and within US legislative arenas. It stood on its own legs, and the odds have grown longer against its eventual enactment as a separate legislative program.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" chronicled the pre-1996 developments of residency tuition and the application to undocumented college students. It highlighted the federal role in the governance of immigration-relation status, benefits, and categories of students and the current architecture of residency requirements that was established. The first version of what is known now as the DREAM Act was introduced in Congress in 2001, and many observers thought it would be easily enacted into law. But it did not enter the world naked. Prior to its proposed enactment, several news stories were written about successful college students whose parents had brought them to the United States as children, who either entered without inspection or entered legally and then overstayed a visa, or did one of the many things that can render a family out of status."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-3",
      "id": "chapter2_3",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" These children stayed in school by virtue of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler v. Doe")]), _vm._v(", the 1982 Supreme Court case that struck down restrictive Texas laws that would have allowed school districts to charge tuition or to ban unauthorized students outright from the public school."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-4",
      "id": "chapter2_4",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Over the many years since "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v(", school districts have accommodated the children, who against all odds were graduating from high school and applying to colleges and universities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-5",
      "id": "chapter2_5",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("When their numbers began to grow and attracted attention, some public higher education institutions and states began to impose residency restrictions. Such restrictions precluded undocumented students from achieving domiciliary-based residency tuition (effectively creating a reprise of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v(" in postsecondary guise) or charged them tuition rates as if they were international students without visas."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-6",
      "id": "chapter2_6",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Other states and institutions allowed students to establish residency and to pay the lower, in-state tuition; private institutions, which traditionally do not charge tuition based on state residency criteria, either allowed them to enroll or held that they could not do so, often on the grounds that to do so would implicate their standing to issue I-20 visa documents, such as those employed by traditional F-1 or M-1 international students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-7",
      "id": "chapter2_7",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Given their many educational disadvantages, their ineligibility to receive most state aid and any federal financial assistance, and their inability to work "), _c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("while in school, only a small number of undocumented students were actually affected by state and postsecondary educational institutions’ reactions to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-8",
      "id": "chapter2_8",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Then, lightning struck with the passage of Proposition 187, California’s 1994 ballot initiative designed to eliminate virtually all state benefits to undocumented immigrants."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-9",
      "id": "chapter2_9",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" This draconian measure, passed overwhelmingly by the state’s electorate, would have stripped undocumented aliens of all but the most essential health and emergency medical services, would have overruled "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v(" and denied educational benefits to these children, and would have required public officials to report undocumented aliens’ suspected status to police and security authorities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-10",
      "id": "chapter2_10",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Almost immediately, declaratory and injunctive relief was granted by federal courts, and ultimately almost all of Proposition l 87’s provisions were struck down. The bar on postsecondary residency, however, was upheld."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-11",
      "id": "chapter2_11",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" By the mid-1990s, a number of states had also challenged what they considered failed federal immigration enforcement policy, seeking additional federal resources."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-12",
      "id": "chapter2_12",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Six of the major receiver states brought such suits; all were eventually unsuccessful."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-13",
      "id": "chapter2_13",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("At approximately the same time, Representative Elton Gallegly (R-CA) introduced federal legislation to overturn "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v(", and while the “Gallegly Amendment” was unsuccessful,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-14",
      "id": "chapter2_14",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" the Republican-controlled Congress in 1995 enacted two major 1996 laws restricting immigration and the status of immigrants: the Personal Responsibility and Work Opportunity Reconciliation Act of 1996 and the Illegal Immigration Reform and Immigrant Responsibility Act of 1996 —both signed into law by President Bill Clinton."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-15",
      "id": "chapter2_15",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" These omnibus laws dramatically changed the landscape, affecting federal benefits in many areas of health and welfare, including the requirement that, if a state wished to accord resident tuition status and eligibility to the undocumented, it must do so “only through the enactment of a State law after August 22, 1996, which affirmatively provides for such eligibility.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-16",
      "id": "chapter2_16",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The enactment of these federal statutes led the judge in the challenge to Proposition 187"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-17",
      "id": "chapter2_17",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" to determine that the federal government preempted similar state actions expressing the “intention of Congress to occupy the field of regulation of government benefits to aliens.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-18",
      "id": "chapter2_18",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" When the state of California appealed this decision, the newly elected governor, Gray Davis, invoked the Ninth Circuit’s special arbitration and mediation provision, which resulted in "), _c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("a July 1999 settlement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-19",
      "id": "chapter2_19",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Thus, the case was never appealed to the Supreme Court, and for several years efforts at residency tuition legislation were stalled, that is until June 2001, when Texas passed the first statute to accord the state resident tuition allowed by IIRIRA and PRWORA, affirmatively providing resident status to immigrant students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-20",
      "id": "chapter2_20",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The same year, on September 11, the world fundamentally changed, and any immediate hopes for immigration reform were dashed by the onset of overwhelming national security concerns and the war on terrorism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-21",
      "id": "chapter2_21",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Even so, federal legislation was introduced in 2001, giving the DREAM Act its acronym."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-22",
      "id": "chapter2_22",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Other states followed Texas’s lead, and through 2019 nearly two dozen states allowed undocumented students to establish residency and pay in-state tuition: one state (Oklahoma) had granted this status and then rescinded its financial aid provisions, while Wisconsin rescinded its tuition statute after two years, with very few students having invoked its benefits."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-23",
      "id": "chapter2_23",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" South Carolina voted to ban the undocumented from attending its public colleges."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-24",
      "id": "chapter2_24",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The other states allowed them to enroll but charged them nonresident tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-25",
      "id": "chapter2_25",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Given undocumented students’ ineligibility to secure lawful employment, these students did not qualify for jobs in college or after graduation, and no one saw DACA as an alternative in the making."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-26",
      "id": "chapter2_26",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Depending on the jurisdiction and occupation, they may or may not be licensed or gain authorization for skilled professions such as teaching, law, or the medical professions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-27",
      "id": "chapter2_27",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" As is evident from the narratives that follow, this is highly contested terrain, especially considering how few such students exist in the context of more than 18 million college students. At the time, no estimates exceeded 50,000–60,000 students nationally each year,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-28",
      "id": "chapter2_28",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" which would constitute the enrollment at the main Columbus campus of The Ohio State University. In order to clear up the confusion on the issue, and to provide a path to legalization for the affected students after their graduation, the DREAM Act was introduced in 2001, in essentially its present form."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-29",
      "id": "chapter2_29",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In 2005, the Washington Legal Foundation (WLF) filed a complaint with the Department of Homeland Security (DHS) to challenge the Texas and New York statutes regarding undocumented students, although it is not entirely clear why this agency would have jurisdiction over these sections of IIRIRA."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-30",
      "id": "chapter2_30",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" As of spring 2014, a decade later, no action had been taken on this matter by DHS, and discussions with at"), _c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("torneys and officials involved indicated that there would be no action forthcoming."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-31",
      "id": "chapter2_31",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Indeed, the answer was issued in a response to a different question, one posed by North Carolina officials about their own admissions policies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-32",
      "id": "chapter2_32",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" In July 2008, DHS had indicated that any determinations of tuition residency or admissions policy by states were state matters, not in the federal domain:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("[T]he individual states must decide for themselves whether or not to admit illegal aliens into their public post-secondary institutions. States may bar or admit illegal aliens from enrolling in public post-secondary institutions either as a matter of public policy or through legislation. Please note, however, that any state policy or legislation on this issue must use federal immigration status standards to identify which applicants are illegal aliens. In the absence of any state policy or legislation addressing this issue, it is up to the schools to decide whether or not to enroll illegal aliens, and the schools must similarly use federal immigration status standards to identify illegal alien [sic] applicants."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-33",
      "id": "chapter2_33",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("This would also be the appropriate response to the 2005 WLF complaint to the DHS as well, for state tuition and admissions policies have always been state issues, and it is surprising that a state entity would pose such a question, implicitly suggesting that the determination of a state status might turn on a federal determination; one wonders what the North Carolina response would have been had the federal department responded that the federal government actually would assert jurisdiction over the matter. The DHS response to the North Carolina query occurred during the final stages of the appellate decision being rendered in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martinez v. Regents of the University of California")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-34",
      "id": "chapter2_34",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" but the court did not take notice of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Day v. Sibelius")]), _vm._v(", lawyers challenged the Kansas statute allowing undocumented college students to establish residency status for tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-35",
      "id": "chapter2_35",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" The judge ruled for the state, finding that the plaintiffs did not have standing to bring suit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-36",
      "id": "chapter2_36",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" The Federation for American Immigration Reform filed an appeal to the federal court of appeals, and on August 30, 2007, the Tenth Circuit affirmed the trial court decision in the case."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-37",
      "id": "chapter2_37",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" The United State Supreme Court denied the petition for certiorari, thereby upholding the statute."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-38",
      "id": "chapter2_38",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("In December 2005, the same groups that filed the Kansas matter filed in California state court challenging AB 540,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-39",
      "id": "chapter2_39",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" the California residency statute, on a parallel track, hoping to prevent the practice at both the federal and state levels."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-40",
      "id": "chapter2_40",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" In October 2006, FAIR’s attempt to bring a case similar to the Kansas federal case in California state court lost when the trial judge ruled against them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-41",
      "id": "chapter2_41",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" However, in fall 2008, an appellate court overturned the decision, ordered the matter back to trial, and found against the state."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-42",
      "id": "chapter2_42",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The University of California announced that it would be appealing the AB 540 appellate court ruling to the state supreme court and, just as important for students in the short term, would continue to award AB 540 tuition exemptions during the appeal process."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-43",
      "id": "chapter2_43",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Thus, in the country’s largest state, with the largest number of undocumented students and largest number of college students, the entire program was clouded by the possibility that the California Supreme Court could uphold the plaintiffs and render the program a violation of federal law. This did not happen, as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martinez v. UC Regents")]), _vm._v(" unanimously reversed the appeals court in late 2010 and found for the state and the students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-44",
      "id": "chapter2_44",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In another higher education immigration/residency case that occurred in California during this period, a number of immigrant organizations filed suit in November 2006 to challenge California’s postsecondary residency and financial aid provisions"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-45",
      "id": "chapter2_45",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Student Advocates for Higher Education et al v. Trustees, California State University et al")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-46",
      "id": "chapter2_46",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Citizen students with undocumented parents were being prevented from receiving the tuition and financial aid benefits due to them, at least in part because the California statute was not precisely drawn (or was being imperfectly administered, in several instances). The challenge highlighted several overlapping policies: immigration, financial aid independence/dependence upon parents, and the age of majority/domicile."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-47",
      "id": "chapter2_47",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" The state agreed to discontinue the practice and entered into a consent decree resolving the matter in the plaintiffs’ favor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-48",
      "id": "chapter2_48",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The order overturned CSU’s unusual take on undocumented college student residency—that a citizen, majority-age college student with undocumented parents was not able to take advantage of the California statute according the undocumented in-state residence, even if the student were otherwise eligible."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-49",
      "id": "chapter2_49",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" In a similar fashion, the Virginia attorney general and the Colorado attorney general also ruled that US citizen children "), _c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("could establish tuition residency status on a case-by-case basis, even if their parents were undocumented."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-50",
      "id": "chapter2_50",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" These rulings made a virtue of necessity, inasmuch as citizen children who reach the age of majority by operation of law establish their own domicile: their parents’ undocumented status is (or should be) irrelevant to the ability of the children to establish residency or eligibility for other postsecondary benefits or status on the basis of citizenship status. Flash forward to 2010, the time of the final "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martinez")]), _vm._v(" decision, and two more states were also found to have similar criteria: New Jersey in its awards of state financial aid,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-51",
      "id": "chapter2_51",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" and Florida in its even more fundamental residency requirement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-52",
      "id": "chapter2_52",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In 2005, the state of Texas enacted several modifications to its postsecondary residency statutes (Senate Bill 1528) and the implementing Texas Coordinating Board regulations, some of which affected undocumented students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-53",
      "id": "chapter2_53",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" These revisions made it slightly easier for students to avail themselves of in-state tuition and ended the anomalous situation where international students (required to maintain foreign domiciles in F-1 visa status) took advantage of the original statute and regulations. In an interesting twist, following the California appellate decision, a restrictionist Texas state legislator requested an attorney general opinion, seeking to apply the intermediate appellate decision in the California "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martinez")]), _vm._v(" case. In response, on July 23, 2009, the Texas attorney general waffled, concluding that the Texas tuition law would “not likely” violate the Equal Protection Clause of the Fourteenth Amendment, but refused to issue an opinion on whether the in-state tuition law would be preempted by federal law."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-54",
      "id": "chapter2_54",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Texas governor Rick Perry, who in 2001 had signed the original legislation establishing House Bill 1403, said he would not accept or sign any changes to the state law."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-55",
      "id": "chapter2_55",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In a related development, the same Texas attorney general issued an opinion saying that the phrase “citizen of Texas” in the state’s Hazlewood Act (a military scholarship program) should be interpreted as a person who lives in the state and is a US citizen."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-56",
      "id": "chapter2_56",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Prior to this opinion, Texas public colleges and universities gave the Hazlewood benefit to all qualifying military veterans, regardless of whether they were US citizens or lawful permanent residents when they entered the military. In 2007, two Mexican American permanent resident veterans were rendered ineligible under this revised criterion; they brought suit, which was resolved in 2008, when the state attorney general reversed his position."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-57",
      "id": "chapter2_57",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Following the lead of Texas, New Mexico in January 2005 became the first state to enact residency tuition for the undocumented who graduated from the state’s high schools and met the other residency requirements; it also extended resident tuition to the undocumented and altered its residency statutes for some American Indians and for Texans from border counties."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-58",
      "id": "chapter2_58",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" In doing so, it became among the most generous program, extending financial aid and lottery scholarship eligibility as well as resident tuition, with only a twelve-month durational requirement.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Many state-level developments took place in 2006. In January, the Utah attorney general issued an opinion, determining that the Utah statute granting tuition status to the state’s undocumented college students was constitutional."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-59",
      "id": "chapter2_59",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Although the state enacted considerably tighter legislation in 2008, barring the undocumented from many benefits, the move to repeal this tuition provision failed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-60",
      "id": "chapter2_60",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" A safe harbor was created, and the state’s senior US senator, widely regarded as a conservative legislator, continued his advocacy for passing federal immigration legislation that would grant legalization to college students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-61",
      "id": "chapter2_61",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Also in January 2006, the Massachusetts legislature voted down a measure that would have accorded in-state tuition to the undocumented."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-62",
      "id": "chapter2_62",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" In 2007, the governor proposed to abolish tuition at the state’s community colleges, but the proposal did not gain traction due to financial difficulties."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-63",
      "id": "chapter2_63",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" In 2008, another false start occurred when the governor decided not to pursue extending resident tuition to the students in any public college sector, citing the economic downturn."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-64",
      "id": "chapter2_64",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Early in 2007, legislation was introduced in Minnesota,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-65",
      "id": "chapter2_65",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" both to broaden residency and to restrict it. At the end of a complicated session, on May 30, 2007, Minnesota governor Tim Pawlenty signed into law an interesting partial victory for in-state/residency tuition advocates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-66",
      "id": "chapter2_66",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Under the Minnesota bill, a number of the state college system institutions eliminated nonresident rates altogether, allowing anyone, apparently regardless of state of residence or immigration status, to qualify for the flat (formerly in-district) rate. The press coverage on this never fully sussed the entire legislation, which was complex and originally included a specific DREAM Act provision that was ultimately stripped."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-67",
      "id": "chapter2_67",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" While the legislation somewhat finessed the larger issue (and contained a 2009 sunset provision), this approach had a nimble aspect to it, removing the immigration dimension."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-68",
      "id": "chapter2_68",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" It was an intriguing approach, as many "), _c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("DREAM Act students are likely to attend two-year colleges."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-69",
      "id": "chapter2_69",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" In Texas, even before HB 1403 passed, several large community college districts had moved to this practice of in-district tuition, led by the Houston and Dallas community college systems, which were the real precursors of this practice in Texas."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-70",
      "id": "chapter2_70",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Many of these students enroll in transfer curricula; however, partly due to the rising costs, other administrative and paperwork requirements, and their inability to work for pay, these students rarely ended up transferring to senior colleges."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-71",
      "id": "chapter2_71",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Given the declining state appropriation support for higher education and the difficult economy, eliminating tuition seems an unlikely scenario for any college sector, especially the burgeoning two-year universe, which has been inundated with overflow enrollments from strapped senior institutions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-72",
      "id": "chapter2_72",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" In addition, it is not clear in all states how state law affects local two-year college tuition policies, which are often district or county determinations based on “attendance zone districts” or substate line-drawing cartography.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("On January 23, 2006, the Colorado attorney general issued an opinion on whether the state coordinating board had the authority to grant in-state residency status; he held that the Colorado Commission on Higher Education did not have such authority."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-73",
      "id": "chapter2_73",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" However, in 2007, he determined that state residency law did allow citizen students of undocumented parents to establish residency if they otherwise met the durational requirements."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-74",
      "id": "chapter2_74",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" In this decision, he opined: “[B]ecause it is the student, rather than the parents, who is the legal beneficiary of in-state tuition status, the fact that the parents may be in the country illegally is not a bar to the student’s receipt of that benefit.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-75",
      "id": "chapter2_75",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" At the same time, Colorado newspapers reported on undocumented Colorado students who, through a reciprocal arrangement with New Mexico colleges, were allowed to attend New Mexico public colleges and to pay resident tuition. In addition, a single state college acted on its own before the state mooted the point in 2012, when it enacted a statute."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-76",
      "id": "chapter2_76",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("On April 14, 2006, Nebraska became the tenth state to provide in-state tuition to undocumented immigrant students who had attended and graduated from Nebraska high schools. It did so in dramatic fashion, overriding Governor Dave Heineman’s veto. The bill passed by a 26–19 margin but needed thirty votes for an override; supporters managed to change exactly four votes to reach the necessary thirty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-77",
      "id": "chapter2_77",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("During this period in the spring of 2006, very large crowds of immigrants and their supporters held widely publicized rallies, called “"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("marchas")]), _vm._v(",” drawing substantial attention in the media."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-78",
      "id": "chapter2_78",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" By one estimate, more than half a million persons marched in Los Angeles alone, even risking apprehension by police and immigration authorities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-79",
      "id": "chapter2_79",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" These were the first national, substantial public displays of support on behalf of immigrants, and they energized supporters and opponents alike."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-80",
      "id": "chapter2_80",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("On September 30, 2006, California governor Arnold Schwarzenegger declined to sign S.B. 160, vetoing a bill that would have allowed undocumented students in California, already eligible for in-state tuition, to participate in the state’s financial aid grant programs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-81",
      "id": "chapter2_81",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" The state’s budget crisis was beginning to become evident, and higher education suffered a large cut in support, including closing programs, limiting enrollments in many institutions, and even furloughing faculty and staff."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-82",
      "id": "chapter2_82",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Several other states enacted legislation affecting international students, though these did not implicate in-state tuition status for the undocumented students who remained ineligible. Virginia extended tuition status to political refugees,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-83",
      "id": "chapter2_83",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" while Wyoming enacted state scholarship programs valuable only to residents who are lawful permanent residents (LPRs) or citizens."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-84",
      "id": "chapter2_84",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" During 2006, additional states considered but did not enact resident tuition statutes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-85",
      "id": "chapter2_85",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The pace did not slow in 2007. The Oklahoma Taxpayer and Citizen Protection Act of 2007 repealed the 2003 financial aid provision that accorded residency tuition and grants to eligible undocumented students (although the actual language of the bill, signed into law in May 2007, continued residency exceptions and grandfathered in those students already eligible and enrolled.)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-86",
      "id": "chapter2_86",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" In January 2008, Oklahoma’s Board of Regents issued a memo outlining the new policies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-87",
      "id": "chapter2_87",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Even so, restrictionists prevailed in the repeal action, making Oklahoma the only state to have extended this status and aid and then to have rescinded the state grant eligibility.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In spring 2007, Connecticut’s legislature passed and sent a bill to Governor Jodi Rell for her signature, which would have granted alien students who graduated from the state’s high schools the opportunity to qualify for resident tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-88",
      "id": "chapter2_88",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" She vetoed the bill on June 26, 2007, and wrote: “I understand these students are not responsible for their undocumented status, having come to the United States with their parents. The fact re"), _c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("mains, however, that these students and their parents are here illegally and neither sympathy nor good intentions can ameliorate that fact.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-89",
      "id": "chapter2_89",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In fall 2007, uncertainties arose over what the more restrictionist state statutes from Georgia and Arizona would mean for this issue, and things were in flux in these two states. Georgia held public hearings in April 2007 to obtain public input as to how it should proceed, but the behind-the-scenes waiver system, which allowed each public college to use waivers for up to 2 percent of their headcount, changed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-90",
      "id": "chapter2_90",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" The statute took effect on July 1, 2007."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-91",
      "id": "chapter2_91",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" At the start of the spring 2007 semester, Arizona officials were confused about what to do with the statute’s new requirements."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-92",
      "id": "chapter2_92",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" However, they decided that they would not enroll these students any longer, and by summer 2007 they reported that nearly 5,000 students had been removed from the state’s institutions and adult basic education classes. In response, Arizona State University awarded students private money to help with financial aid needs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-93",
      "id": "chapter2_93",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" The funds (contested by the same political opponents who enacted the restrictionist legislation) ran out in spring 2008; the overall fiscal crisis in the state has continued, causing furloughs of regular faculty and severe cutbacks in college services."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-94",
      "id": "chapter2_94",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Following the lead in Missouri, which in 2007 saw the introduction of a death-penalty provision that would have banned undocumented students from enrolling in any fashion in its public colleges, Virginia legislators introduced a similar bill in the legislature in August 2007. The legislation died."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-95",
      "id": "chapter2_95",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The Missouri Senate Committee on Pensions, Veterans’ Affairs, and General Laws heard testimony on March 14, 2007, on five proposed bills, including the Missouri Omnibus Immigration Act and a bill to ban undocumented students from enrolling in public institutions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-96",
      "id": "chapter2_96",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" The Missouri legislation was not enacted in 2007."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-97",
      "id": "chapter2_97",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" In 2008, the Missouri legislature considered two separate bills addressing the undocumented college student tuition issue, one in the state house and one in the state senate: HB 1463 would have prohibited state institutions of higher education from admitting undocumented individuals. It was not enacted, as the legislature ran out of time in May 2008."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-98",
      "id": "chapter2_98",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" However, House Bill 1549 was enacted into law and incorporated by reference the federal provisions of sections 1621 and 1623; Missouri public and private colleges have acted as if the legislation prohibits them from enrolling students without legal "), _c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("status after January 1, 2009."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-99",
      "id": "chapter2_99",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" By restating the 1621 and 1623 provisions, the Missouri statutory scheme parses federal law (“public benefits”) in a fashion not dictated by the language. The "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martinez")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-100",
      "id": "chapter2_100",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" state court litigation in California also turned on this crucial statutory construction, already construed by the federal decisions in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Merten")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-101",
      "id": "chapter2_101",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sibelius")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-102",
      "id": "chapter2_102",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" If the legislative language simply incorporated the federal language, there was no need for the Missouri statute to have been enacted, especially if the IIRIRA and PWORA provisions require a state to take a formal action before according resident tuition to these students. If they are ineligible for the tuition status, as they were prior to the enactment, then no legislative action was required for determining or denying college resident status. This confusing set of events, especially in light of the clear July 2008 DHS apportionment of state authority to establish state policy, is most likely explained as a punitive measure to stake out political ground and to force immigrant supporters to go on record so that the vote—even on an unnecessary and superfluous matter—can be used in future elections as a signal of conservative political correctness.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The year 2008 started out with a bang, including ongoing national electoral politics over tuition benefits. In Virginia, citizen applicants of undocumented parents were the subject of an attorney general memo; the memo advised its client colleges to deal with these students on a case-by-case basis for residency tuition purposes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-103",
      "id": "chapter2_103",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" In Utah, although a comprehensive restrictionist state law was enacted in 2008, it exempted undocumented college students from its coverage, so they remained eligible for resident tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-104",
      "id": "chapter2_104",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In North Carolina, an odd and twisted scenario occurred in 2008. Early in the year, the state’s community colleges indicated that they would enroll undocumented students and charge them in-district tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-105",
      "id": "chapter2_105",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" In May, the attorney general’s office issued a letter (which is less binding than an attorney general opinion), indicating that the state’s colleges were not allowed even to enroll the undocumented, much less accord them resident tuition, citing DHS policy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-106",
      "id": "chapter2_106",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" When the state officials sought actual guidance from DHS, the department indicated that, to the contrary, states were able to determine their own policy in accord with sections 1621 and 1623."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-107",
      "id": "chapter2_107",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" After receiving this guidance, state college officials indicated that they would not enroll the students at in-state tuition rates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-108",
      "id": "chapter2_108",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "aria-label": "36",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("A similarly confused reading of federal law occurred in Arkansas, where schools had silently enrolled students until it became publicly known and the state higher education agency and governor ended the practice; an Arkansas attorney general opinion ruled that Arkansas law allowed the undocumented to attend state institutions, although not at resident tuition rates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-109",
      "id": "chapter2_109",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" In September 2008, Alabama’s two-year college board also moved to ban their attendance."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-110",
      "id": "chapter2_110",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" In 2008 and 2009, resident tuition legislation was considered but not enacted in Maryland, Colorado, Virginia, Nebraska, Ohio, and New Jersey."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-111",
      "id": "chapter2_111",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("In June 2008, South Carolina became the first state to enact state legislation that banned undocumented students from even attending public colleges; a decade later made it impossible for DACA students to gain resident tuition eligibility; and also played hardball for what should have been an easy call: residency tuition for US citizen children of undocumented parents. But after prevailing on the issue at the Fourth Circuit, it agreed to rewrite their regulations and accord them resident tuition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-112",
      "id": "chapter2_112",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" Charging non-resident tuition in the other states has allowed few such students to enroll; the prohibitions on federal financial assistance make it virtually impossible for undocumented students to attend colleges and pay nonresident rates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-113",
      "id": "chapter2_113",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Even in Texas, the first state to enact a law broadening its tuition status and the state with the longest border adjoining Mexico, official figures for 2007 revealed there to be only 9,062 undocumented enrollees out of the total public college enrollment of 1,102,572 full-time students, or fewer than 1 percent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-114",
      "id": "chapter2_114",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" In Washington, of the 427 students applying for and receiving “WA 1079” status in 2007–08, only 314 were presumed to be undocumented."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-115",
      "id": "chapter2_115",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" California’s data were not widely available, but reports revealed that nearly two-thirds of the beneficiaries of AB 540 were citizens who had either moved away from the state or who were able to claim the in-state status because of the statutory language that grandfathered in former high school graduates as “residents.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-116",
      "id": "chapter2_116",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" In June 2009, Wisconsin became the eleventh state to offer the tuition provision, although later events led to its rescission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-117",
      "id": "chapter2_117",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" As late as 2010, action was under way in New Jersey and Rhode Island to enact law extending resident tuition status to the undocumented, while in Texas and Nebraska, efforts were undertaken to rescind earlier statutes, both by litigation and legislation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-118",
      "id": "chapter2_118",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('span', {
    attrs: {
      "aria-label": "37",
      "id": "pg_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("These complex events are examined in detail in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 4")]), _vm._v(" (state developments after 2010). As it would be characterized in Texas, the DREAM Act had become “all-hat-and-no cattle,” a disappointing set of affairs. But as bleak as these developments had appeared in the years leading up to 2010, there was a small but certain sense of momentum, as more and more undocumented students, buoyed by "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Plyler")]), _vm._v(" and positive legislation in California, Texas, and the smaller states. It had also become more obvious that it would have to be the various state laboratories, to paraphrase Justice Louis Brandeis, that would accord the enhanced educational civil rights to undocumented immigrants, envisioned by him as “novel social and economic experiments”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-119",
      "id": "chapter2_119",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" that the Supreme Court should make possible.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0